(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  // The dropdown panels already open via plain CSS (:hover / :focus-within on
  // the [data-nav-item] wrapper) - this only mirrors that open state onto
  // aria-expanded for assistive tech and adds an Escape-to-close nicety. It
  // never toggles a class or drives visibility, so none of it is required
  // for the menu to work with JavaScript disabled.
  function bind(item) {
    if (item.dataset.navBound === 'true') return;
    item.dataset.navBound = 'true';

    var trigger = item.querySelector('[data-nav-trigger]');
    if (!trigger) return;

    function setOpen(isOpen) {
      trigger.setAttribute('aria-expanded', String(isOpen));
    }

    item.addEventListener('mouseenter', function () { setOpen(true); });
    item.addEventListener('mouseleave', function () { setOpen(false); });
    item.addEventListener('focusin', function () { setOpen(true); });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setOpen(false);
    });
    item.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setOpen(false);
        trigger.focus();
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-nav-item]').forEach(bind);
  }

  init(document);
  // The theme editor swaps section markup in without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Progressive enhancement over a form that already works on its own.
    // Everything here is additive: without it the shopper still filters via
    // the submit button, which is why that button is only hidden from
    // desktop AFTER this runs.
    function enhance(form) {
      if (form.dataset.filtersEnhanced === 'true') return;
      form.dataset.filtersEnhanced = 'true';
      form.classList.add('cy-filters-auto');

      // A checkbox is an unambiguous, complete choice the moment it changes,
      // so it can apply itself. Number inputs deliberately do not - see the
      // comment on the price Apply button.
      form.addEventListener('change', function (event) {
        var el = event.target;
        if (!el || el.type !== 'checkbox') return;
        if (el.closest('[data-filter-drawer-toggle]')) return; // the CSS-only drawer switch
        submit(form);
      });

      // Keep empty price boxes out of the URL entirely rather than sending
      // `...price.gte=` with no value on every apply.
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value.trim() === '') input.disabled = true;
        });
      });
    }

    function submit(form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    function init() {
      document.querySelectorAll('form[data-collection-filters]').forEach(enhance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Verbatim copy of sections/main-collection.liquid's enhancement -
    // snippets cannot carry a javascript tag, so this cannot be
    // shared directly. Progressive enhancement over a form that already
    // works on its own; the `filtersEnhanced` guard makes it safe even if
    // both this and the collection section's script ever ran on the same
    // page.
    function enhance(form) {
      if (form.dataset.filtersEnhanced === 'true') return;
      form.dataset.filtersEnhanced = 'true';
      form.classList.add('cy-filters-auto');

      form.addEventListener('change', function (event) {
        var el = event.target;
        if (!el || el.type !== 'checkbox') return;
        if (el.closest('[data-filter-drawer-toggle]')) return; // the CSS-only drawer switch
        submit(form);
      });

      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value.trim() === '') input.disabled = true;
        });
      });
    }

    function submit(form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    function init() {
      document.querySelectorAll('form[data-collection-filters]').forEach(enhance);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
